import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getOrganizationChartItemsOfProject } from '../services/getOrganizationChartItemsOfProject.service';

export const loadProjectOrganizationChartItems = createAsyncThunk(
  'organizationCharts/loadProjectOrganizationChartItems',
  async (projectId, { getState }) => {
    // Callers outside the organization chart scene (the join-employee dialog)
    // are not always looking at the selected project, so they pass their own.
    const effectiveProjectId = projectId || selectSelectedProjectId(getState());

    const response = await getOrganizationChartItemsOfProject(
      effectiveProjectId
    );

    return response;
  }
);
